import create from "zustand"

/**
 * @type {import("./types").TConfirmModalStore}
 */
const useConfirmModal = create(set => ({
  showModal: false,
  showWarning: true,
  message: "",
  handler: {
    showConfirm: true,
    showCancel: false,
    confirmButtonProps: {
      variant: "primary",
    },
    cancelButtonProps: {
      variant: "primary",
    },
  },

  openModal: () => set({showModal: true}),
  closeModal: () => set({showModal: false}),
  toggleModal: () => set(state => ({showModal: !state.showModal})),
  createConfirmModal: (message, handler, showWarning = true) =>
    set({
      showModal: true,
      showWarning,
      message,
      handler: {
        showConfirm: handler?.showConfirm || true,
        showCancel: handler?.showCancel || false,
        handleConfirm: handler?.handleConfirm,
        handleCancel: handler?.handleCancel,
        confirmText: handler?.confirmText,
        cancelText: handler?.cancelText,
        confirmButtonProps: handler?.confirmButtonProps,
        cancelButtonProps: handler?.cancelButtonProps,
      },
    }),
}))

export default useConfirmModal
